import { FieldWrapper, Label, NumberInput } from '@commenda/kakashi';
import { TBaseHumanStepDefinition } from '@commenda/types';
import { useWorkflow } from '../../context/WorkflowContext';
import { TSelectedEntity } from '../../types/node';
import { parseMsToTimeUnits, timeUnitsToMs, TTimeUnits } from './duration';

export const EstimatedTimeToCompleteConfig = ({
  selectedEntity,
}: {
  selectedEntity: TSelectedEntity;
}) => {
  const { workflow, setWorkflow } = useWorkflow();

  const selectedStep = workflow?.steps.find(
    (step) => step.id === selectedEntity.id
  ) as TBaseHumanStepDefinition;

  if (!selectedStep) return null;

  const currentMs = selectedStep.estimatedTimeToComplete?.durationMs ?? 0;
  const timeUnits = parseMsToTimeUnits(currentMs);

  const updateEstimatedTime = (updates: Partial<TTimeUnits>) => {
    const durationMs = timeUnitsToMs({ ...timeUnits, ...updates });

    setWorkflow({
      ...workflow,
      steps: workflow?.steps.map((step) =>
        step.id === selectedEntity.id
          ? {
            ...step,
            estimatedTimeToComplete: { durationMs },
          }
          : step
      ),
    });
  };

  return (
    <FieldWrapper>
      <Label>Estimated Time to Complete</Label>
      <div className="flex items-center gap-2">
        <div className="flex items-center gap-1">
          <NumberInput
            value={timeUnits.days}
            onChange={(value) => updateEstimatedTime({ days: value ?? 0 })}
            min={0}
            className="w-12 text-center"
            placeholder="0"
          />
          <span className="text-text-secondary txt-small-regular">d</span>
        </div>
        <div className="flex items-center gap-1">
          <NumberInput
            value={timeUnits.hours}
            onChange={(value) => updateEstimatedTime({ hours: value ?? 0 })}
            min={0}
            max={23}
            className="w-16 text-center"
            placeholder="0"
          />
          <span className="text-text-secondary txt-small-regular">h</span>
        </div>
        <div className="flex items-center gap-1">
          <NumberInput
            value={timeUnits.minutes}
            onChange={(value) => updateEstimatedTime({ minutes: value ?? 0 })}
            min={0}
            max={59}
            className="w-16 text-center"
            placeholder="0"
          />
          <span className="text-text-secondary txt-small-regular">m</span>
        </div>
        <div className="flex items-center gap-1">
          <NumberInput
            value={timeUnits.seconds}
            onChange={(value) => updateEstimatedTime({ seconds: value ?? 0 })}
            min={0}
            max={59}
            className="w-16 text-center"
            placeholder="0"
          />
          <span className="text-text-secondary txt-small-regular">s</span>
        </div>
      </div>
    </FieldWrapper>
  );
};
